import { LanguageContext } from '@/contexts';
import { LANGUAGE } from '@/enums';
import classNames from 'classnames';
import i18next from 'i18next';
import { useContext, useMemo } from 'react';
import { SwitchLanguageButtonWrapper, SwitchLanguageSelect } from './styles';
import { useGetSubdomainQuery } from '@/hooks';
import { defaultLanguageOptions } from '@/constants';

interface Props {
  position?: 'unset' | 'fixed';
}

const SwitchLanguageButton = (props: Props) => {
  const { position = 'unset' } = props;
  const { language, isLoading, setLanguage, supportedLanguages } =
    useContext(LanguageContext);

  const isFixed = position === 'fixed';
  const { subdomain } = useGetSubdomainQuery();

  const options = useMemo(() => {
    return subdomain !== 'amili' && !isLoading
      ? supportedLanguages.map((lang: string) => ({
          label: lang.toUpperCase(),
          value: lang.toLowerCase(),
        }))
      : defaultLanguageOptions.map(value => ({
          label: value.toUpperCase(),
          value: value,
        }));
  }, [supportedLanguages, subdomain, isLoading]);

  return (
    <SwitchLanguageButtonWrapper style={{ position }}>
      <SwitchLanguageSelect
        type="default"
        options={options}
        placement="bottomRight"
        showSearch={false}
        popupMatchSelectWidth={false}
        suffixColor={isFixed ? 'white' : ''}
        defaultValue={language ?? LANGUAGE.EN}
        className={classNames(
          'switch-language-select',
          isFixed ? 'fixed' : 'relative',
        )}
        onChange={value => {
          setLanguage(value as string);
          i18next.changeLanguage(value as string);
        }}
      />
    </SwitchLanguageButtonWrapper>
  );
};

export default SwitchLanguageButton;
